import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function FundFamilyTerms() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#050505]" data-testid="fund-family-terms-page">
      <header className="sticky top-0 z-50 glass-darker border-b border-white/5">
        <div className="max-w-3xl mx-auto px-4 py-4 flex items-center gap-4">
          <button onClick={() => navigate(-1)} className="text-zinc-400 hover:text-white">
            <ArrowLeft size={20} />
          </button>
          <h1 className="font-heading text-xl font-bold text-white">Fund a Family Terms</h1>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-4 py-8">
        <div className="prose-invert space-y-6 text-zinc-300 text-sm leading-relaxed">
          <p className="text-zinc-500 text-xs">Last updated: February 2026</p>

          <Section title="What is Fund a Family?">
            Fund a Family is a community initiative within Bitcoin Brain. When you purchase any tier, you can optionally add $21 to fund Bitcoin Brain access for a working family who cannot afford it. This is a voluntary, non-refundable contribution.
          </Section>

          <Section title="How Contributions Work">
            Your $21 contribution is processed as part of your purchase (via Stripe or Strike). The full payment amount goes to Bryce Fields (Bitcoin Brain). Contributions are tracked internally and allocated to approved Fund a Family applications. <strong className="text-white">Contributions are not tax-deductible</strong> — Bitcoin Brain is not a registered 501(c)(3) nonprofit organization.
          </Section>

          <Section title="How Applications Work">
            Families who cannot afford Bitcoin Brain can submit an application at bitcoinbrain.space/fund-a-family. Applications include the applicant's name, email, household size, a written explanation of their financial situation, and optionally a proof document (EBT/SNAP card, Medicaid, free/reduced lunch letter, WIC document, or Section 8 voucher).
          </Section>

          <Section title="Review and Approval">
            All applications are reviewed personally by Bryce Fields, the Bitcoin Brain founder. Approval is at his sole discretion. No application is guaranteed approval. Factors considered include the written explanation, household size, whether proof was provided, and available pool balance.
          </Section>

          <Section title="What Funded Families Receive">
            Approved applicants receive Standard tier access to Bitcoin Brain — the full 21-section course, quizzes, AI assistant, achievements, and badges. Funded families do not receive Genesis, Early Believer, or Educator tier status. Access is granted to the email address provided on the application.
          </Section>

          <Section title="Proof Documents">
            Proof documents are optional but strengthen an application. Accepted documents include EBT/SNAP cards, free/reduced lunch letters, Medicaid cards, WIC documents, and Section 8 vouchers. Applicants should blur any identifying numbers — we only need to see the document type and name. Proof documents are reviewed only by Bryce Fields and are deleted within 30 days of review.
          </Section>

          <Section title="No Guarantee">
            Submitting a Fund a Family contribution does not guarantee that a specific family will be funded. Submitting a Fund a Family application does not guarantee approval. Bitcoin Brain reserves the right to modify or discontinue the Fund a Family program at any time.
          </Section>

          <Section title="Contact">
            Questions about Fund a Family? Email <a href="mailto:bitcoinbrain21m@gmail.com" className="text-[#F7931A] hover:underline">bitcoinbrain21m@gmail.com</a>
          </Section>
        </div>
      </main>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div>
      <h2 className="text-white font-heading font-bold text-base mb-2">{title}</h2>
      <p>{children}</p>
    </div>
  );
}
